import React, { Component } from 'react'
import { StyleModal } from './style'
import { Button } from '../..'
export class ModalInformation extends Component {
  render() {
    const {
      headerName,
      colorTheme,
      descriptionName,
      buttonName,
      onClick
    } = this.props
    return (
      <StyleModal colorTheme={colorTheme}>
       <div className='div-modal' />
        <div className='content-modal'>
          <div className='head-modal'>
            {headerName}
          </div>
            <div className='description'>
              <p className='p-description'>{descriptionName}</p>
              <Button
                name={buttonName}
                onClick={onClick}
                className='modal-btn-confirm'
              />
          </div>
        </div>
      </StyleModal>
    )
  }
}
